"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCopy = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconCopy = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.083 6H1.917A1.917 1.917 0 000 7.917v14.166C0 23.142.858 24 1.917 24h14.166A1.917 1.917 0 0018 22.083V7.917A1.917 1.917 0 0016.083 6zM16 8v14H2V8h14z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M22 0a2 2 0 011.987 1.767L24 2v14a2 2 0 01-1.767 1.987L22 18h-5v-2h5V2H8v5H6V2A2 2 0 017.767.013L8 0h14z"
}));
exports.IconCopy = IconCopy;
//# sourceMappingURL=IconCopy.js.map